import { render, staticRenderFns } from "./LecturerInfo.vue?vue&type=template&id=ebbf94f2&"
import script from "./LecturerInfo.vue?vue&type=script&lang=js&"
export * from "./LecturerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports